import { Routes } from '@angular/router';

export const adminContentRoutes: Routes = [
    {
        path: $localize`:@@adminContentPath:zawartosc`,
        loadComponent: () => import('src/app/rokezzz/blog/admin/views/blog/blog.component').then(module => module.RokezzzBlogViewComponent),
        data: {
            path: 'admin.content',
        },
        children: [
            {
                path: $localize`:@@adminContentHomePath:strona-glowna`,
                loadComponent: () => import('src/app/rokezzz/setting/views/setting/setting.component').then(module => module.RokezzzSettingViewComponent),
                data: {
                    title: $localize`Strona główna`,
                    settingGroup: 'home/',
                    path: 'admin.content.home',
                }
            },
            {
                path: $localize`:@@adminContentAboutPath:o-firmie`,
                loadComponent: () => import('src/app/rokezzz/setting/views/setting/setting.component').then(module => module.RokezzzSettingViewComponent),
                data: {
                    title: $localize`O firmie`,
                    settingGroup: 'about/',
                    path: 'admin.content.about',
                }
            },
            {
                path: $localize`:@@adminContentOfferPath:oferta`,
                loadComponent: () => import('src/app/rokezzz/setting/views/setting/setting.component').then(module => module.RokezzzSettingViewComponent),
                data: {
                    title: $localize`Oferta`,
                    settingGroup: 'offer/',
                    path: 'admin.content.offer',
                }
            },
            {
                path: $localize`:@@adminContentPromotionPath:promocja`,
                loadComponent: () => import('src/app/rokezzz/setting/views/setting/setting.component').then(module => module.RokezzzSettingViewComponent),
                data: {
                    title: $localize`Promocja`,
                    settingGroup: 'promotion/',
                    path: 'admin.content.promotion',
                }
            },
            {
                path: $localize`:@@adminContentChildrenBranchPath:filia-dziecieca`,
                loadComponent: () => import('src/app/rokezzz/setting/views/setting/setting.component').then(module => module.RokezzzSettingViewComponent),
                data: {
                    title: $localize`Filia dziecięca`,
                    settingGroup: 'childrenBranch/',
                    path: 'admin.content.childrenBranch',
                }
            },
            {
                path: $localize`:@@adminContentContactPath:kontakt`,
                loadComponent: () => import('src/app/rokezzz/setting/views/setting/setting.component').then(module => module.RokezzzSettingViewComponent),
                data: {
                    title: $localize`Kontakt`,
                    settingGroup: 'contact/',
                    path: 'admin.content.contact',
                }
            },
            {
                path: $localize`:@@adminContentRegulationsPath:regulaminy`,
                loadComponent: () => import('src/app/rokezzz/setting/views/setting/setting.component').then(module => module.RokezzzSettingViewComponent),
                data: {
                    title: $localize`Regulaminy`,
                    settingGroup: 'regulations/',
                    path: 'admin.content.regulations',
                }
            },
        ]
    },
];
